import * as React from "react";
import { cn } from "../../lib/utils";
import { Check } from "lucide-react";

const Input = React.forwardRef(({ className, type, success, error, ...props }, ref) => (
  <input
    type={type}
    className={cn(
      "flex w-full min-h-12 rounded-md border bg-white px-4 text-body text-foreground placeholder:text-muted-foreground",
      "focus-visible:outline-none focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-primary/20",
      "disabled:cursor-not-allowed disabled:opacity-50",
      success && "border-success focus-visible:border-success focus-visible:ring-success/20",
      error && "border-destructive focus-visible:border-destructive focus-visible:ring-destructive/20",
      !success && !error && "border-input",
      className
    )}
    ref={ref}
    aria-invalid={error ? "true" : undefined}
    {...props}
  />
));
Input.displayName = "Input";

const Label = React.forwardRef(({ className, required, children, ...props }, ref) => (
  <label ref={ref} className={cn("block text-body font-medium text-foreground mb-2", className)} {...props}>
    {children}
    {required && <span className="text-destructive ml-1" aria-hidden="true">*</span>}
  </label>
));
Label.displayName = "Label";

const FieldError = ({ message, className }) =>
  message ? (
    <p className={cn("text-caption text-destructive mt-2", className)} role="alert">
      {message}
    </p>
  ) : null;

const FieldSuccess = ({ message, className }) =>
  message ? (
    <p className={cn("text-caption text-success mt-2 flex items-center gap-1", className)} role="status">
      <Check size={14} strokeWidth={1.75} aria-hidden="true" />
      {message}
    </p>
  ) : null;

export { Input, Label, FieldError, FieldSuccess };
